<template>
  <v-dialog
    v-model="dialogDetail"
    max-width="1000px"
    transition="dialog-transition"
    @keydown.esc="close"
  >
    <v-card flat class="no__radius no__padding no__padding-scroll table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1" v-if="!loading">
      <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
        <h2>{{item.nazev_sporeni}}</h2>
      </v-card-title>
      <div class="gui-flex gui-flex-rows px-0">

        <v-card class="pa-0 mt-3 elevation-0" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-card-text class="pa-0">
            <v-tabs v-model="activeTab" color="transparent" slot="extension" class="mlm10">
              <v-tab :key="1" ripple>
                Informace
              </v-tab>
              <v-tab :key="2" ripple>
                Platby
              </v-tab>
              <v-tab :key="3" ripple>
                Roční bonusy
              </v-tab>
              <!-- <v-tab :key="4" ripple>
                Graf postupného nákupu
              </v-tab> -->
              <v-tab :key="4" ripple>
                Předané produkty
              </v-tab>
            </v-tabs>
            <div class="px-0">
              <v-card class="pa-1 mt-3 elevation-0">
                <v-card-text class="pa-0">
                  <v-tabs-items v-model="activeTab">
                    <v-tab-item :key="1">

                      <v-card class="pa-0 elevation-0">
                        <v-card-text class="pa-0">
                          <v-layout row wrap>
                            <v-flex xs12 sm9>
                              <v-layout row wrap class="mb-4">
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Datum sjednání:</p> <strong>{{item.datum_sjednani | formatDate}}</strong>
                                </v-flex>
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Variabilní symbol:</p> <strong>{{item.variabilni_symbol}}</strong>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap class="mt-3">
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Cílová částka:</p>
                                  <strong>{{item.cilova_castka | formatMoney}} {{item.mena.zkratka}}</strong>
                                </v-flex>
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Slitek:</p>
                                  <strong>{{item.cilovy_produkt.nazev}}</strong>
                                </v-flex>
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Měsíční platba:</p>
                                  <strong>{{item.mesicni_platba | formatMoney}}</strong>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap class="mt-3">
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Naspořeno kusů:</p>
                                  <strong>{{item.pocet_dosporenych_produktu}}</strong>
                                </v-flex>
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Předáno:</p>
                                  <strong>{{item.predane_produkty.length}}</strong>
                                </v-flex>
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Způsob předání:</p>
                                  <strong v-if="item.zpusob_predani != null">{{item.zpusob_predani.nazev}}</strong>
                                  <strong v-else>--</strong>
                                </v-flex>
                              </v-layout>

                              <!-- <v-layout row wrap class="mt-3">
                                <v-flex xs12 sm4>
                                  <p class="grey--text caption mb-1">Průměrná cena slitku:</p>
                                  <strong>--</strong>
                                </v-flex>
                              </v-layout> -->
                            </v-flex>
                            <v-flex xs12 sm3>
                              <div class="actual-purchase">
                                <div class="slitek">
                                  <zaplaceno-procent :title="item.nasporena_castka_procento>=100?'Vše zaplaceno':'Rozespořeno'" :procento="item.nasporena_castka_procento >= 100 ? 100 : item.rozesporeno_procent" :obrazek="item.cilovy_produkt.obrazky.length > 0 ? $imagesBaseUrl + item.cilovy_produkt.obrazky[0].s3_nazev : null"></zaplaceno-procent>
                                </div>
                              </div>
                              <!-- <ul class="pl-2">
                                <li>Zbývá: xxx g</li>
                                <li>Roční bonus: xxx g <br> (při doplacení xxx Kč do 31. 12.)</li>
                              </ul> -->
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <hr class="dialog-hr mt-3 mb-4">

                      <v-card class="pa-0 elevation-0">
                        <v-card-text class="pa-0">
                          <v-layout row wrap class="mt-3">
                            <v-flex xs12 sm6>
                              <p class="grey--text caption mb-1">Zaplaceno z cílové částky:</p> <strong>{{item.celkem_zaplaceno | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <p class="grey--text caption mb-1">Zbývá doplatit z poplatku:</p>
                              <strong>{{item.poplatek_zbyva | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="mt-3">
                            <v-flex xs12 sm6 v-if="item.prumerna_cena != null && item.prumerna_cena > 0">
                              <p class="grey--text caption mb-1">Průměrná cena nákupu:</p>
                              <strong>{{item.prumerna_cena | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="item.doplatit_cp != null && item.doplatit_cp > 0">
                              <p class="grey--text caption mb-1">Zbývá k doplacení aktuálně rozespořeného kusu:</p>
                              <strong>{{item.doplatit_cp | formatMoney}} {{item.mena.zkratka}}</strong>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="2">
                      <div class="gui-flex gui-flex-rows">
                        <div class="mb-3 no__radius">
                          <v-data-table
                            :headers="platbyHeaders"
                            :items="item.platby"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.datum | formatSimpleDate }}</td>
                              <td>{{ props.item.castka | formatMoney }} Kč</td>
                              <td>{{ props.item.variabilni_symbol }}</td>
                              <td>{{props.item.popis}}</td>
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </v-tab-item>
                    <v-tab-item :key="3">
                      <div class="gui-flex gui-flex-rows">
                        <div class="table-border__radius elevation-0 mb-3">
                          <v-data-table
                            :headers="rocniBonusyHeaders"
                            :items="item.bonusovy_kov"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.datum_od }} - {{ props.item.datum_do }}</td>
                              <td class="text-xs-right"><span v-if="props.item.castka > 0">{{ props.item.castka | formatMoney }} {{item.mena.zkratka}}</span></td>
                              <td class="text-xs-right">{{ props.item.bonusovy_kov | formatMoney }} g</td>
                              <td class="text-xs-right">
                                <!-- TODO doplnit připsání -->
                                <span v-if="props.item.datum_pripsani">ANO ({{ props.item.datum_pripsani | formatSimpleDate }})</span>
                                <span v-else></span>
                              </td>
                              <!-- <td class="text-xs-right">{{ props.item.bonusovy_kov_castka | formatMoney }} Kč</td> -->
                            </template>
                          </v-data-table>
                        </div>
                        <p class="body-3 mb-0 mt-3 pl-2 pr-2" v-if="item.bonusovy_kov_narok.zbyva_zaplatit > 0"><span class="bold">Poznámka:</span>
                        </p>
                        <p class="body-3 mb-0 mt-2 pl-2 pr-2" v-if="item.bonusovy_kov_narok.zbyva_zaplatit > 0">
                          Předběžný nárok je <span class="bold">{{item.bonusovy_kov_narok.g | formatMoney}} g</span> bonusového kovu.<br />Bonusový kov bude připsán
                          na Váš  účet, pokud do <span class="bold">31. 12.</span> bude uhrazeno <span class="bold">{{item.bonusovy_kov_narok.zbyva_zaplatit | formatMoney}} Kč</span>.
                        </p>
                      </div>
                    </v-tab-item>
                    <!-- <v-tab-item :key="4">Graf postupného nákupu</v-tab-item> -->
                    <v-tab-item :key="4">
                      <div class="gui-flex gui-flex-rows">
                        <div class="table-border__radius elevation-0 mb-3">
                          <v-data-table
                            :headers="predaneProduktyHeaders"
                            :items="item.predane_produkty"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.datum | formatSimpleDate }}</td>
                              <td><eshop-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank" class="link-black">{{ props.item.produkt.nazev }}</eshop-link></td>
                              <td class="text-xs-right">{{ props.item.mnozstvi }} ks</td>
                              <!-- <td>
                                <span v-if="props.item.predano">Předáno</span>
                                <span v-else-if="props.item.informovan">K předání</span>
                              </td> -->
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
        </v-card>

        <v-card-actions class="mt-5 pa-0" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <!-- <a :href="moje ? (api_url + 'nakupy/sporici-programy/' + id + '/pdf') : (api_url + 'klient/nakupy/'+klient+'/sporici-programy/' + id + '/pdf')" target="_blank"><v-btn color="orange" dark depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF objednávku</v-btn></a> -->
          <v-btn color="orange" dark depressed class="ma-0" @click="downloadPDF"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF objednávku</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-3 elevation-0" class="bold" @click="close" v-if="!updating">Zavřít</v-btn>
        </v-card-actions>
      </div>

    </v-card>
    <v-card v-else>
      <v-card-text class="pa-5">
        <Loader skin="light"></Loader>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/*import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import Platby from '@/pages/Klienti/Platby'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'*/
export default {
  data () {
    return {
      dialogDetail: true,
      loading: true,
      editMode: false,
      activeTab: 0,
      // tabs: [ 'informace', 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      tabs: [ 'informace', 'platby', 'rocni_bonusy', 'predane_produkty' ],
      item: {},
      newItem: {},
      updating: false,
      platbyHeaders: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka' },
        { text: 'Variabilní symbol', value: 'variabilni_symbol' },
        { text: 'Účel platby', value: 'variabilni_symbol' }
      ],
      rocniBonusyHeaders: [
        { text: 'Období', value: 'datum', sortable: false },
        { text: 'Částka platby', value: 'castka_platby', align: 'right', sortable: false },
        { text: 'Bonusový kov', value: 'bonusovy_kov', align: 'right', sortable: false },
        { text: 'Připsáno', value: 'pripsano', align: 'right', sortable: false }
        // { text: 'Bonus v Kč', value: 'bonus_kc', align: 'right', sortable: false }
      ],
      predaneProduktyHeaders: [
        { text: 'Datum', value: 'datum', sortable: false },
        { text: 'Produkt', value: 'produkt', sortable: false },
        { text: 'Množství', value: 'mnozstvi', sortable: false, align: 'right' }
        // { text: 'Stav', value: 'stav', sortable: false }
      ],
    }
  },
  props: {
    id: String,
    klient: String,
    moje: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    },
    me () {
      return window.$me;
    }
  },
  mounted: function() {
    this.load();
  },
  watch: {
    dialogDetail (v) {
      if (!v)
        this.$emit("close");
    }
  },
  methods: {
    load () {
      if (typeof this.klient != "undefined" && this.klient != null) {
        window.api.get("klient/nakupy/"+this.klient+"/sporici-programy/" + this.$props.id).then((_body) => {
          this.item = _body;
          this.loading = false;
        }).catch((err) => {
          console.log(err);
          this.loading = false;
        });
      }
      else {
        window.api.get("nakupy/sporici-programy/" + this.$props.id).then((_body) => {
          this.item = _body;
          this.loading = false;
        }).catch((err) => {
          console.log(err);
          this.loading = false;
        });
      }
    },
    close () {
      this.$emit('close');
    },
    downloadPDF () {
      var url = this.moje ? ('nakupy/sporici-programy/' + this.id + '/pdf') : ('klient/nakupy/'+this.klient+'/sporici-programy/' + this.id + '/pdf');
      window.api.download(url);
    }
  },
  components: {
    //RocniBonusy, Platby, PredaneProdukty
  }
}
</script>
